<template>
  <div class="asd20-directory-people-results-page">
    <p
      style="margin: 1rem; text-align: left;"
      v-if="filteredPeopleListItems.length >= 250"
    >
      Showing the first 250 results. Use <b>Search</b> or choose a
      <b>Job Type</b> to narrow your results.
    </p>
    <h2
      style="margin: 1rem 0 0 1rem; text-align: left;"
      v-if="selectedJobTypes.length > 0"
    >
      Viewing Job Type:
      <b>{{ selectedJobTypes.toString().replace(/,/g, ', ') }}</b>
    </h2>
    <br />
    <!-- <p style="margin: 0 0 1rem 1rem;">
      Use <b>Search</b> or choose another <b>Job Type</b> to narrow your
      results.
    </p> -->
    <asd20-list multi-column :column-width="640">
      <asd20-list-item
        v-for="(item, index) in filteredPeopleListItems"
        :key="index"
        v-bind="item"
        @click.native="onPersonClick(item)"
      />
    </asd20-list>
    <Asd20PersonModal
      :person="selectedPerson"
      :open="!!selectedPerson"
      @dismiss="selectedPerson = null"
    />
  </div>
</template>

<script>
import { get, sync } from 'vuex-pathify'
import Asd20List from '@asd20/ui/src/components/organisms/Asd20List'
import Asd20ListItem from '@asd20/ui/src/components/molecules/Asd20ListItem'
import Asd20PersonModal from '@asd20/ui/src/components/organisms/Asd20PersonModal'

export default {
  name: 'Asd20DirectoryPeopleResultsPage',

  components: { Asd20List, Asd20ListItem, Asd20PersonModal },

  computed: {
    filteredPeopleListItems: get('people/filteredPeopleListItems'),
    selectedOrganizations: sync('people/selectedOrganizations'),
    selectedOffices: sync('people/selectedOffices'),
    selectedJobTypes: sync('people/selectedJobTypes'),
  },
  props: {
    people: { type: Array, default: () => [] },
  },
  data: () => ({
    loadingPeople: false,
    selectedPerson: null,
  }),
  methods: {
    onPersonClick(item) {
      this.selectedPerson = item.person
    },
  },
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_mixins.scss';
@import '@asd20/ui/src/design/_variables.scss';

.asd20-directory-people-results-page {
  display: flex;
  flex-direction: column;
  margin: 0 space(0.5) space(0.5) space(0.5);
  font-family: var(--website-typography__font-family-headlines);
}

@media (min-width: 1024px) {
  .asd20-directory-people-results-page {
    padding: space(1);
  }
}
</style>
